import {LayerDef} from "./LayerDef";
import {Hill} from "./Hill";
import {HillLists, LayerDefBase} from "./LayerDefBase";
import {Style} from "ol/style";
import {COLOURS} from "./Colours";

export class CorbettsLayerDef extends LayerDefBase implements LayerDef {
    private visitedStyle = LayerDefBase.buildStyle(6, COLOURS.CORBETT.VISITED);
    private unvisitedStyle = LayerDefBase.buildStyle(
        6,
        COLOURS.CORBETT.UNVISITED
    );

    getProgressElement(): HTMLDivElement {
        return document.getElementById("progress-corbett") as HTMLDivElement;
    }

    getCountElement(): HTMLDivElement {
        return document.getElementById("count-corbett") as HTMLDivElement;
    }

    protected getUnvisitedStyle(): Style {
        return this.unvisitedStyle;
    }

    protected getVisitedStyle(): Style {
        return this.visitedStyle;
    }

    protected getLayerHills(hillLists: HillLists): Hill[] {
        return hillLists.main.filter((h) => h.categories.includes("CORBETT"));
    }

    getName(): string {
        return "Corbetts";
    }
}
